import React, { useState, useEffect } from 'react';
// import { PartyLive } from '../components/Icons';
import { AiOutlineAntDesign } from "react-icons/ai";
import { firebaseConfig } from './credentials';

import { db, auth } from '../functions/firebaseFunctions'

import axios from 'axios';

const API_KEY = firebaseConfig.apiKey;

function capitalizeFirstLetter(string) {

  if (string.indexOf('_') != -1) {

  } else {

    string = string.replace(/_/g, ' ');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default function SearchResultItem(props) {
  const { item, navigation, searchType, select, clear, setErr, favVenues } =
    props;

  const uid = auth.currentUser?.uid;
  const types = [];
  item?.types?.every((type) => {
    if (types.indexOf(type) == -1) {
      types.push(type);
    }
  });
  const [PL, setPL] = useState(false);
  const [once, setOnce] = useState(true);
  const [isFavorite, setIsFavorite] = useState(false);
  // let uid1=auth.currentUser.uid
  useEffect(() => {
    getFavs();
  }, []);
  const getFavs = () => {
    if (favVenues) {
      favVenues.forEach((ven) => {
        if (ven.id == item.id) {
          setIsFavorite(true);
        }
      });
    }
  };
  const getDetails = async (now) => {

    axios
      .request({
        method: 'post',
        url: `https://maps.googleapis.com/maps/api/place/details/json?key=${API_KEY}&place_id=${item.id}&fields=website`,
      })
      .then((response) => {
        console.log('AXIOS')
        const data = response.data;
        if (data.status == 'OK') {
          item.website = data.result.website ? data.result.website : null;
          item.timestamp = now.toString();
          db
            .collection('places')
            .doc(item.id)
            .set({
              ...item,
            })
            .then((res) => { });
          // db.ref(`places/${item.id}`).update(item).catch(e=>{setErr(e)})
        }
      })
      .catch((e) => {
        setErr(e);
      });
  };

  if (once) {

    if (favVenues) {
      favVenues.forEach((ven) => {

        if (ven.id == item.id) {
          setIsFavorite(true);
        }
      });
    }
    db.collection('venue')
      .where('venueId', '==', item.id)

      .get().then((res) => {
        if (!res.empty) {
          item.owner = res.docs[0].data().owner;
          db.collection('users')
            // .where('venueId','==',item.id)
            .doc(res.docs[0].data().owner)

            .get().then((res) => {
              if (res.data().disabled == false) {

              } else {
                setPL(true);
              }
            });

        }

      });
    // db.ref('venues/'+item.id).once('value').then(res=>{
    //     const val = res.val()
    //     if(val){
    //         item.owner = val.info.owner
    //         setPL(true)
    //     }
    // }).catch(e=>{setErr(e)})
    setOnce(false);
  }

  return (
    <div
      style={{
        marginVertical: 5,
        padding: 10,
        backgroundColor: 'var(--drg)',
        borderRadius: 5,
        flexDirection: 'row',
      }}
      onClick={() => {
        if (searchType == 'address') {
          setErr(null);
          if (PL) {
            setErr({
              code: 'VenueExists',
              message: 'Venue with this ID has already been registered',
            });
          } else {
            select(item);
            clear();
          }
        } else if (searchType == 'place') {
          setErr(null);
          select(item);
          clear();
        } else {
          setErr(null);
          if (PL) {
            navigation.navigate('Venue', {
              venueId: item.id,
              ownerId: item.owner,
            });
          } else {
            navigation.navigate('Place', { item: item });
          }
        }
      }}
    >
      {/* <PartyLive size={50} YORP={PL} /> */}
      <div style={{ marginLeft: 5, flex: 1, justifyContent: 'center' }}>
        <div style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <p
            style={{ color: 'white', flex: 1 }}
            // numberOfLines={1}
            ellipsizeMode="tail"
          >
            {item.name}
          </p>
          {uid && (
            <div
              style={{ marginLeft: 5 }}
              onClick={() => {
                if (isFavorite) {

                  db.collection('users').doc(uid).get().then((user) => {
                    if (user.exists) {
                      let favs = user.data().favVenues;
                      if (favs.length > 0) {
                        let filteredArr = favs.filter(x => x.id != item.id);
                        db.collection('users').doc(uid).update({ favVenues: filteredArr });
                      }
                    }
                  }).catch((err) => {
                  });
                } else {
                  let tempFav = db
                    .collection('users')
                    .doc(auth.currentUser?.uid)
                    .get()
                    .then((users) => {

                      let tempFav = [];
                      if (users.data()?.favVenues?.length > 0) {
                        tempFav = users.data().favVenues;
                      } else {
                        tempFav = [];
                      }
                      const update = {
                        name: item.name,
                        id: item.id,
                      };
                      let isFav = false;
                      if (tempFav.length > 0) {
                        let ind = tempFav.filter(x => x.id == update.id);
                        if (ind.length > 0) {
                          isFav = true;
                        }
                      }
                      if (!isFav) {
                        tempFav.push(update);
                      }

                      if (auth.currentUser) {
                        db
                          .collection('users')
                          .doc(auth.currentUser?.uid)
                          .set(
                            {
                              favVenues: tempFav,
                            },
                            { merge: true }
                          )
                          .then(() => {
                            db
                              .collection('places')
                              .get()
                              .then((res) => {
                                const now = new Date();
                                if (!res.empty) {
                                  let arr = res?.docs;
                                  let index = arr.findIndex(x => x.data().id == item.id);
                                  if (index == -1) {
                                    getDetails(now);
                                  }
                                  //   let temp=res?.docs?.map(x=>{
                                  //     if( x.data().id==item.id  ){

                                  //         if(!(new Date(x.data().timestamp).valueOf() > (now.valueOf() - 2678400000))){
                                  //             getDetails(now)
                                  //         }

                                  //     }
                                  //     // x.id==item.id
                                  // })
                                } else {
                                  getDetails(now);
                                }
                                setIsFavorite(true);
                              })
                              .catch((e) => {
                                setErr(e);
                              });
                            // navigation.navigate('Event',{uid:uid,type:sel})
                          })
                          .catch((error) => {
                            console.error('Error writing document: ', error);
                          });
                        return tempFav;
                      }

                    });

                }
              }}
            >
              <AiOutlineAntDesign
                // name={isFavorite ? 'heart' : 'hearto'}
                size={24}
                color={'var(--red)'}
              />
            </div>
          )}
        </div>
        <div
          style={{ flexDirection: 'row', flexWrap: 'wrap', marginVertical: 5 }}
        >
          {searchType !== 'place' &&
            types.map(
              (i) =>
                i != 'establishment' &&
                i != 'point_of_interest' && (
                  <p key={item.id + '_' + i} style={{ color: 'var(--org)' }}>
                    {'| ' + capitalizeFirstLetter(i) + ' '}
                  </p>
                )
            )}
        </div>
        <p style={{ color: 'var(--ltg)' }}>{item.address}</p>
      </div>
    </div>
  );
}
